/**
 * Sets up Primary Nav and manages dropdown states
 *
 * @since 0.1.0
 */

// import {$body} from './references.js';

// console.log('Site:primary-nav');

// eslint-disable-next-line no-unused-vars

import * as references from './references.js';

setupPrimaryNavDropdowns();
setupMobileNav();

function setupPrimaryNavDropdowns() {
  const navItemsWithChildren = document.querySelectorAll('.menu-item-has-children > a');

  for (let i = 0; i < navItemsWithChildren.length; i++) {
    navItemsWithChildren[i].addEventListener('click', (e) => {
      const isActive = e.target.parentNode.classList.contains('dropdown-active');

      for (let j = 0; j < navItemsWithChildren.length; j++) {
        navItemsWithChildren[j].parentNode.classList.remove('dropdown-active');
      }

      if (!isActive) {
        e.target.parentNode.classList.add('dropdown-active');
      }

      e.preventDefault();
    });
  }
}

function setupMobileNav() {
  const menuPrimaryContainer = document.querySelectorAll('.menu-primary-container');

  const mobileMenuTrigger = document.querySelectorAll('.mobile-menu-trigger');

  const header = document.querySelector('#header');

  // menuPrimaryContainer[0].style.top = getHeaderHeight() + 'px';


  for (let i = 0; i < mobileMenuTrigger.length; i++) {
    mobileMenuTrigger[i].addEventListener('click', (e) => {
      console.log(e);

      references.$window.scrollTop(0);

      // header[0].scrollTop(0)

      // console.log(header[0]);

      references.$body[0].classList.toggle('mobile-nav-open');
      menuPrimaryContainer[0].classList.toggle('animated');
    });
  }
}

// function getHeaderHeight() {
//   let headerHeight = 0;

//   const header = document.getElementById('header');

//   if (header) {
//     headerHeight = header.offsetHeight;
//   }

//   return headerHeight;
// }
